import React, { useState, useEffect, useContext } from "react";
import LayoutDashboard from "../../Components/Layout/LayoutDashboard";
import {
  Grid,
  Box,
  Paper,
  Button,
  TextField,
  Typography,
  FormControl,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { useForm } from "react-hook-form";
import SchedulesContext from "../../Reducers/Schedules/SchedulesContext";
import SelectGraduateCourses from "../SelectOptions/SelectGraduateCourses";
import IndividualCoursesList from "./IndividualCoursesList";
import MethodGet from "../../Config/Services";
/**Importar Sweetalert2 * */
import Swal from "sweetalert2";
/**importar spinner */
import Spinner from "../../Complements/Spinner";
/** Importar Moment */
import Moment from "moment";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  container: {
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
    paddingLeft: theme.spacing(10),
    //marginBottom: theme.spacing(10),
  },
  typography: {
    margin: theme.spacing(1),
    //paddingLeft: theme.spacing(30),
  },
  form: {
    width: "100%", // Fix IE 11 issue.
    marginTop: theme.spacing(9),
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    marginBlockEnd: theme.spacing(1),
  },
  submit: {
    background: "indigo",
    "&:hover": {
      background: "#5902CF",
    },
    color: "white",
  },
  formControl: {
    margin: theme.spacing(1),
    width: "100%",
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
  input: {
    display: "none",
  },
  containerImageProfile: {
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap",
    justifyContent: "space-around",
  },
  PaperFormAdd: {
    background: "white",
    color: "black",
    boxShadow: "2px 4px 4px #cacaca",
  },
}));

export default function ScheduleAdd(props) {
  const classes = useStyles();

  const [cargando, spinnerCargando] = useState(false);

  const [capacity, saveCapacity] = useState(0);

  const [disableButton, saveDisableButton] = useState(false);

  const handleChangeCapacity = (e) => {
    saveCapacity(e.target.value);
  };

  const formScheduleContext = useContext(SchedulesContext);

  const { ErrorsAPI, success, AddSchedule } = formScheduleContext;

  const [school, saveSchool] = useState({});

  const [courses, saveCourses] = useState([]);

  //Extraer valores de branch(destructuracion)
  const { name } = school;

  const [graduateCourse, saveGraduateCourse] = useState("");

  const detectarCambiosGraduateCourses = (value) => {
    saveGraduateCourse(value.key);
  };

  const [classroom, saveClassroom] = useState("");

  //obtenemos la escuela de session storage
  let SchoolStorageID = JSON.parse(sessionStorage.getItem("school"));

  //Funcion para validaciones
  const { register, handleSubmit, errors } = useForm();

  //obtener los campos de la sucursal
  useEffect(() => {
    let url = `/branches/${SchoolStorageID}`;
    MethodGet(url)
      .then((res) => {
        saveSchool(res.data.data);
        spinnerCargando(true);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  //obtener los cursos de un diplomado
  useEffect(() => {
    let url = `/coursesDetails/${graduateCourse}`;
    MethodGet(url)
      .then((res) => {
        saveCourses(res.data.data);
        spinnerCargando(true);
      })
      .catch((error) => {
        console.log(error);
      });
  }, [graduateCourse]);

  const onSubmit = (data, e) => {
    data.course = graduateCourse;
    var courses_list = JSON.stringify(courses);
    data.courses_list = courses_list;
    data.type = 2;
    if (data.course != "") {
      AddSchedule(data);
    } else {
      Swal.fire({
        title: "Error",
        text: "Todos los campos son Obligatorios",
        icon: "error",
      });
    }
  };

  useEffect(() => {
    //si success retorna verdadero la pagina redireccionara al index de programaciones
    if (success) {
      props.history.push(`/ProgramacionesCursos`);
    }
  }, [success]);

  //  spinner de carga
  if (!cargando) return <Spinner />;

  return (
    <LayoutDashboard>
      <div className={classes.root}>
        <Paper className={classes.PaperFormAdd}>
          <form
            onSubmit={handleSubmit(onSubmit)}
            className={classes.form}
            noValidate
          >
            <Box>
              <Typography
                component="h1"
                variant="h5"
                align="center"
                className={classes.typography}
              >
                Agregar Programacion de Curso En La Escuela {name}
              </Typography>
            </Box>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6}>
                <FormControl
                  variant="outlined"
                  className={classes.formControl}
                  style={{ marginTop: "25px" }}
                >
                  <SelectGraduateCourses
                    detectarCambiosGraduateCourses={
                      detectarCambiosGraduateCourses
                    }
                    SchoolStorageID={SchoolStorageID}
                  />
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  margin="normal"
                  required
                  fullWidth
                  id="capacity"
                  label="Capacidad Del Diplomado"
                  name="capacity"
                  onChange={handleChangeCapacity}
                  autoComplete="capacity"
                  type="number"
                  defaultValue="0"
                  autoFocus
                  InputLabelProps={{
                    shrink: true,
                  }}
                  inputProps={{
                    step: 300, // 5 min
                  }}
                  error={!!errors.end_time}
                  inputRef={register({
                    required: {
                      value: true,
                      message: "La Capacidad es requerida",
                    },
                  })}
                />
                <p>{errors?.end_time?.message}</p>
              </Grid>
              <Grid item xs={12}>
                <IndividualCoursesList
                  courses={courses}
                  saveCourses={saveCourses}
                  SchoolStorageID={SchoolStorageID}
                  capacity={capacity}
                  saveDisableButton={saveDisableButton}
                />
              </Grid>
            </Grid>
            {!graduateCourse ? (
              <Grid
                container
                spacing={3}
                justify="center"
                style={{ marginBottom: 10 }}
              >
                <Grid item spacing={3} xs={12} sm={12} md={6}>
                  <Button
                    style={{ color: "white", background: "grey" }}
                    type="submit"
                    fullWidth
                    disabled
                    variant="outlined"
                    className={classes.submit}
                  >
                    GUARDAR DIPLOMADO
                  </Button>
                </Grid>
              </Grid>
            ) : (
              <Grid
                container
                spacing={3}
                justify="center"
                style={{ marginBottom: 10 }}
              >
                <Grid item spacing={3} xs={12} sm={12} md={6}>
                  <Button
                    type="submit"
                    fullWidth
                    variant="outlined"
                    className={classes.submit}
                  >
                    GUARDAR DIPLOMADO
                  </Button>
                </Grid>
              </Grid>
            )}
          </form>
        </Paper>
      </div>
    </LayoutDashboard>
  );
}
